<template lang='pug'>
  p.product-price(v-if='variant && variant.attributes')
    template(v-if='variant.attributes["under-sale"]')
      span.product-price-sale-old(v-text='humanizePrice(variant.attributes["original-price"])')
      span.product-price-sale-new(v-text='humanizePrice(variant.attributes.price)')
      span.product-price-sale-text(v-if='variant.attributes["sale-text"]' v-text='saleTextForDisplay')

    template(v-else)
      span(v-text='humanizePrice(variant.attributes.price)' data-ge-price)
</template>

<script>
import { humanizePrice } from '@/modules/services/price-support'

export default {
  props: {
    variant: {
      type: Object,
      default: () => {}
    },

    saleTextWithParentheses: {
      type: Boolean,
      default: true
    },

    showOffWord: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    saleText () {
      return this.variant.attributes['sale-text'].toUpperCase()
    },

    saleTextForDisplay () {
      let text = this.saleTextWithParentheses ? this.parenthesesSaleText : this.saleText
      if (!this.showOffWord) {
        text = text.replace(' OFF', '')
      }

      return text
    },

    parenthesesSaleText () {
      return `(${this.saleText})`
    }
  },

  methods: {
    humanizePrice
  }
}
</script>
